import React from 'react'
function TooltipText({ src, alt, tooltipText, className = '' }) {
    return (
        <div className={`tooltip-image-container ${className}`}>
            <img src={src} alt={alt}
                height={18}
                width={18} />
            <span className="tooltip-text">{tooltipText}</span>
        </div>
    )
}

export default TooltipText;